import React from "react";
import { Table, Input, Select } from "antd";
import { MODE_SCREEN } from "../../constants/common.const";
import { renderOption } from "../../constants/utils";
import { Typography } from 'antd';

const { Paragraph } = Typography;

const EquipmentContentTable = ({
  mode = MODE_SCREEN.VIEW,
  data = {},
  setData = () => {},
  setIsDirty={setIsDirty}
}) => {
  
  const changeValue =
    (key) =>
    (e) => {
      const value = e.target ? e.target.value : e;
      console.log(value)
      setData({ ...data, [key]: { ...data[key], value } });
      setIsDirty(true)
    };
 
   
  const columns = (mode) => [
    {
      title: "管理方法",
      key: "ManagementMethod",
      align:"center",
      width:"20%",
      render: () =>
        mode === MODE_SCREEN.VIEW ? (
          data.managementMethod.valueString
        ) : (
          <Select
          value={data.managementMethod.value}
          className="w100"
            onChange={changeValue("managementMethod")} >
              {renderOption(data.managementMethod.options)}
            </Select>
            
          
        ),
    },
    {
      title: "優先度",
      key: "priorityLevelLevel",
      render: () =>
        mode === MODE_SCREEN.VIEW ? (
          data.priorityLevel.value
        ) : (
          <Input
            onChange={changeValue("priorityLevel")}
            value={data.priorityLevel.value}
          />
        ),
    },
    {
      title: "重要度",
      key: "importanceLevel",
      render: () =>
        mode === MODE_SCREEN.VIEW ? (
          data.importanceLevel.value
        ) : (
          <Input
            onChange={changeValue("importanceLevel")}
            value={data.importanceLevel.value}
          />
        ),
    },
    {
      title: "機械状態判定",
      children: [
        {
          title: "総合",
          dataIndex: "overallCondition",
          key: "overallCondition",
          render: () =>
            mode === MODE_SCREEN.VIEW ? (
              data.overallCondition.value
            ) : (
              <Input
                onChange={changeValue("overallCondition")}
                value={data.overallCondition.value}
              />
            ),
        },
        {
          title: "機能",
          dataIndex: "functionalityCondition",
          key: "functionalityCondition",
          render: () =>
            mode === MODE_SCREEN.VIEW ? (
              data.functionalityCondition.value
            ) : (
              <Input
                onChange={changeValue("functionalityCondition")}
                value={data.functionalityCondition.value}
              />
            ),
        },
        {
          title: "物理",
          dataIndex: "physicalCondition",
          key: "physicalCondition",
          render: (text) =>
            mode === MODE_SCREEN.VIEW ? (
              data.physicalCondition.value
            ) : (
              <Input
                onChange={changeValue("physicalCondition")}
                value={data.physicalCondition.value}
              />
            ),
        },
        {
          title: "補機",
          dataIndex: "auxiliaryEquipmentCondition equipment",
          key: "auxiliaryEquipmentCondition equipment",
          render: () =>
            mode === MODE_SCREEN.VIEW ? (
              data.auxiliaryEquipmentCondition.value
            ) : (
              <Input
                onChange={changeValue("auxiliaryEquipmentCondition")}
                value={data.auxiliaryEquipmentCondition.value}
              />
            ),
        },
      ],
    },
  ];

  const dataSource = [{ ...data }];

  return (
    <>
    <Table
      bordered
      columns={columns(mode)}
      dataSource={dataSource}
      pagination={false}
    />
   
<Paragraph style={{ backgroundColor: '#f4f4f4', padding: '8px 12px',marginTop:20 }}>
  重要度×機器総合判定の総合＝優先度
  <br/>
  <br/>
  ストマネの考えでは
  <br/>
  優先度（リスク評価）
  <br/>
  重要度（影響度）
  <br/>
  機器状態判定（発生確率）という言葉で定義されている。
  <br/>
  なお発生確率は5-健全度で評価することもある。（健全度は１から５で５が健全）
</Paragraph></>

  );
};

export default EquipmentContentTable;
